import { useId, useState } from 'react';

type DisclosureProps = {
  summary: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  /** Count shown beside the trigger — an editor decides whether to open based on it. */
  count?: number;
};

/**
 * The default answer to Art Direction §5: evidence is one motion away, and the motion opens from
 * the trigger's own edge so its origin is obvious.
 */
export function Disclosure({ summary, children, defaultOpen = false, count }: DisclosureProps) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();

  return (
    <div className="disclosure" data-open={open}>
      <button
        type="button"
        className="disclosure__trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen(value => !value)}
      >
        <span className="disclosure__chevron" aria-hidden="true" />
        <span className="disclosure__summary">{summary}</span>
        {count !== undefined && <span className="disclosure__count">{count}</span>}
      </button>
      {/* Always mounted — grid-template-rows 0fr/1fr is what gives the panel a close animation
          instead of an instant unmount (transitions.dev §21 accordion expand). */}
      <div className="disclosure__panel" id={panelId} aria-hidden={!open}>
        <div className="disclosure__panel-inner">{children}</div>
      </div>
    </div>
  );
}
